const actionTypes = {
  ADD_TODO: 'ADD_TODO',
  UPDATE_TODO: 'UPDATE_TODO',
  ADD_USER: 'ADD_USER',
  UPDATE_ACTIVE_MENU: 'UPDATE_ACTIVE_MENU',
  REMOVE_USER: 'REMOVE_USER',
};

export default actionTypes;
